export const GET_COMMENTS = 'comment/getComments';
export const CREATE_COMMENTS = 'comment/createComments';
export const UPDATE_COMMENTS = 'comment/updateComments';
export const DELETE_COMMENT = 'comment/deleteComment';
